import { isPwaInstallButtonAvailable } from '../pwaInstallUtils';

const BUTTON_SELECTOR = '[data-js=pwaInstall]';

function updateInstallButtonVisibility() {
    if (!isPwaInstallButtonAvailable()) {
        return;
    }

    $(BUTTON_SELECTOR).removeClass('d-none');
    window.__scPwaInstallTutorialApi?.updatePromoEntryVisibility?.();
}

function hideButton() {
    window.__scDeferredInstallPrompt = null;
    $(BUTTON_SELECTOR).addClass('d-none');
    window.__scPwaInstallTutorialApi?.updatePromoEntryVisibility?.();
}

// Событие могло прийти до загрузки бандла — тогда его подобрал перехватчик в layout.
updateInstallButtonVisibility();
window.addEventListener('sc:installprompt', updateInstallButtonVisibility);
window.addEventListener('appinstalled', hideButton);

$(document).on('click', BUTTON_SELECTOR, function (e) {
    e.preventDefault();

    const deferredPrompt = window.__scDeferredInstallPrompt;
    if (!deferredPrompt) {
        return;
    }

    // Промпт одноразовый: при отказе кнопку вернёт новый beforeinstallprompt на следующей загрузке.
    deferredPrompt.prompt();
    deferredPrompt.userChoice.finally(hideButton);
});
